// extracted by mini-css-extract-plugin
export default {"container":"contest_container__2EK-p","inner":"contest_inner__1GRJZ","withMaxWidth":"contest_withMaxWidth__18foR","draw-path":"contest_draw-path__3ycTa"};